import imgModule from '../../constants/imageSizes'

const imageSizes = imgModule

const galleryItemsSizes = {
  small: { width: 327, height: 184, aspectRatio: '16/9' },
  medium: { width: 252, height: 142, aspectRatio: '16/9' },
  large: { width: 472, height: 266, aspectRatio: '16/9' }
}
export const PageSocialResponsibility = {
  contentType: 'PageSocialResponsibility',
  fields: [
    {
      id: 'heroEyebrow',
      name: 'Hero Eyebrow',
      type: 'Symbol'
    },
    {
      id: 'heroImage',
      name: 'Hero Image',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns12_52 }
    },
    {
      id: 'introText',
      name: 'Intro Text',
      type: 'Text'
    },
    {
      id: 'socialResponsibilityDescription1',
      name: 'Social Responsibility Description 1 LEFT',
      type: 'Text'
    },
    {
      id: 'socialResponsibilityDescription2',
      name: 'Social Responsibility Description 2 RIGHT',
      type: 'Text'
    },
    {
      id: 'image1',
      name: 'Image 1 (left)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'image2',
      name: 'Image 2 (right)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'quote1',
      name: 'Quote 1',
      type: 'BlockQuote'
    },
    {
      id: 'contentBlock',
      name: 'Content block',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns6_11 }
    },
    {
      id: 'cardsBlock',
      name: 'Cards block',
      type: 'BlockMediaCardGroup',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43 }
    },
    {
      id: 'quote2',
      name: 'Quote 2',
      type: 'BlockQuote'
    },
    {
      id: 'socialInitiativeCards',
      name: 'Social initiative Cards',
      type: 'Array',
      subType: 'ModuleMediaCard',
      validations: [{ size: { min: 1, max: 5 } }],
      imageOptions: { resize: true, sizes: galleryItemsSizes }
    },
    {
      id: 'relatedContent',
      name: 'Related content',
      type: 'BlockRelatedContent'
    }
  ]
}

export const PageSocialResponsibilityPeople = {
  contentType: 'PageSocialResponsibilityPeople',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns5_34 }
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockContent'
    },
    {
      id: 'sectionImage',
      name: 'Section Image',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns12_5269 }
    },
    {
      id: 'quote1',
      name: 'Quote 1',
      type: 'BlockQuote'
    },
    {
      id: 'volunteeringInitiativesTitle',
      name: 'Volunteering Initiatives Title',
      type: 'Text'
    },
    {
      id: 'volunteeringInitiativesDesc1',
      name: 'Volunteering Initiatives Description 1 (left)',
      type: 'Text'
    },
    {
      id: 'volunteeringInitiativesDesc2',
      name: 'Volunteering Initiatives Description 2 (right)',
      type: 'Text'
    },
    {
      id: 'imageGallery',
      name: 'Images Gallery',
      type: 'BlockMediaCardGroup',
      imageOptions: { resize: true, sizes: galleryItemsSizes }
    },
    {
      id: 'contentBlock2',
      name: 'Content block 2',
      type: 'BlockContent'
    },
    {
      id: 'image1',
      name: 'Image 1 (left)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns5_11, lazy: true }
    },
    {
      id: 'image2',
      name: 'Image 2 (right)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'callToAction',
      name: 'Call to action',
      type: 'BlockCallToAction'
    }
  ]
}

export const PageSocialResponsibilityPlanet = {
  contentType: 'PageSocialResponsibilityPlanet',
  fields: [
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { resize: true, sizes: imageSizes.columns5_34 }
    },
    {
      id: 'shortDescription',
      name: 'Short Description',
      type: 'Text'
    },
    {
      id: 'image1',
      name: 'Image 1 (left)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'image2',
      name: 'Image 2 (right)',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns6_43, lazy: true }
    },
    {
      id: 'contentBlock1',
      name: 'Content block 1',
      type: 'BlockContent'
    },
    {
      id: 'sectionImage',
      name: 'Section Image',
      type: 'ModuleMedia',
      imageOptions: { resize: true, sizes: imageSizes.columns12_5269 }
    },
    {
      id: 'contentBlock2',
      name: 'Content block 2',
      type: 'BlockContent'
    },
    {
      id: 'imageGallery',
      name: 'Images Gallery',
      type: 'BlockMediaCardGroup',
      imageOptions: { resize: true, sizes: galleryItemsSizes }
    }
  ]
}

export default {
  PageSocialResponsibility,
  PageSocialResponsibilityPeople,
  PageSocialResponsibilityPlanet
}
